'use strict';

exports.__esModule = true;
var UPDATE_LOCALE = exports.UPDATE_LOCALE = 'locale.UPDATE_LOCALE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/store/locale/types.js
// module id = 264
// module chunks = 49